export default __webpack_public_path__ + "static/authentication-page-27e0102e9d0d82ccb4d40b3f46fc4846.png";